if (!customElements.get('welcome-popup-modal')) {
  customElements.define(
    'welcome-popup-modal',
    class WelcomePopupModal extends ModalDialog {
      constructor() {
        super();
      }
    }
  );
}

(function () {
  var SIGNED_UP_KEY = 'evrytngWelcomePopupSignedUp';
  var DISMISSED_KEY = 'evrytngWelcomePopupDismissedAt';
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
  var SHOW_DELAY_MS = 1000;

  function isSuppressed() {
    try {
      if (window.localStorage.getItem(SIGNED_UP_KEY) === 'true') return true;
      var dismissedAt = window.localStorage.getItem(DISMISSED_KEY);
      if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < THIRTY_DAYS_MS) return true;
    } catch (error) {
      return false;
    }
    return false;
  }

  function markSignedUp() {
    try {
      window.localStorage.setItem(SIGNED_UP_KEY, 'true');
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) — fail open, popup may reappear.
    }
  }

  function markDismissed() {
    try {
      window.localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    } catch (error) {
      // localStorage unavailable — fail open, popup may reappear sooner than 30 days.
    }
  }

  function initCopyCode(modal) {
    var button = modal.querySelector('[data-copy-target]');
    if (!button) return;

    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      button.hidden = true;
      return;
    }

    var codeEl = document.getElementById(button.getAttribute('data-copy-target'));
    var status = modal.querySelector('[data-copy-status]');
    if (!codeEl) return;

    button.addEventListener('click', function () {
      navigator.clipboard
        .writeText(codeEl.textContent.trim())
        .then(function () {
          button.classList.add('is-copied');
          if (status) status.textContent = 'Code copied to clipboard.';
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 2000);
        })
        .catch(function () {
          if (status) status.textContent = 'Copy failed — select the code manually.';
        });
    });
  }

  function init() {
    var modal = document.querySelector('welcome-popup-modal');
    if (!modal) return;

    var closeButton = modal.querySelector('[id^="ModalClose-"]');
    if (closeButton) closeButton.addEventListener('click', markDismissed);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) markDismissed();
    });
    modal.addEventListener('keyup', function (event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') markDismissed();
    });

    initCopyCode(modal);

    if (modal.hasAttribute('data-posted-successfully')) {
      markSignedUp();
      modal.show();
      return;
    }

    if (isSuppressed()) return;

    window.setTimeout(function () {
      if (!isSuppressed()) modal.show();
    }, SHOW_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
